module.exports = __webpack_public_path__ + "img/PXL_20230525_120631611.9d0ca0bf.jpg";